"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageList = void 0;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useStorageClient_1 = require("./useStorageClient");
/**
 * Calls `storage.list` and returns an SWR response. SWR middleware `laggy` is used to make flipping
 * between pages look better, this is done by keeping previously loaded data while new data is loading.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param request - request to pass to `storageClient.list`, this is optional, if not set backend will not be called and result will not be returned
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function useStorageList(entity, request, baseUrl, tokenProvider, config) {
    const storage = (0, useStorageClient_1.useStorageClient)(entity, baseUrl, tokenProvider);
    return (0, swr_1.default)(request ? [`/platform/storage/${entity}/list`, request] : null, (_a) => __awaiter(this, [_a], void 0, function* ([, request]) {
        return request ? storage.list(request) : undefined;
    }), config !== null && config !== void 0 ? config : {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
exports.useStorageList = useStorageList;
